import { __rest } from "tslib";
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { Modal, Button, Checkbox, message } from 'antd';
import aiIntro from '@/images/aiIntro.gif';
import classnames from 'classnames';
import { apiHolder, AiAsstWmBizType } from 'api';
import Loadable from '@loadable/component';
const AiWriteMail = Loadable(() => import('@web-edm/send/AiWriteMail'), {
    resolveComponent: components => components.AiWriteMail,
});
setTimeout(() => {
    AiWriteMail.preload();
}, 11000);
import { getMailContentText, isEmpty } from '@web-edm/send/utils/getMailContentText';
import LxPopover from '../LxPopover/LxPopover';
import WarnIcon from '@web-common/components/UI/Icons/svgs/WarnSvg';
import style from './editor.module.scss';
import { getIn18Text, apis } from 'api';
import { useChatDrawerController, ChatDrawer, useShowAiAssistant } from '@web-ai-asst-wm/components/ChatDrawer';
export const AIWriteAttention = ({ closeTips }) => {
    return (React.createElement("div", { className: style.AIWriteContention },
        React.createElement("img", { src: aiIntro, alt: "" }),
        React.createElement("div", { className: style.info },
            React.createElement("div", { className: style.title }, "\u65B0\u589EAI\u5199\u4FE1\u53CA\u6DA6\u8272\u80FD\u529B\uFF01"),
            React.createElement("div", { className: style.infoMsg }, "AI\u5E2E\u4F60\u5199\u90AE\u4EF6\uFF0C\u53EA\u9700\u8981\u8F93\u5165\u6307\u4EE4\uFF0C\u5373\u53EF\u5E2E\u60A8\u751F\u6210\u4E13\u4E1A\u5F97\u4F53\u7684\u90AE\u4EF6\u5185\u5BB9")),
        React.createElement("div", { className: style.bottom },
            React.createElement(Button, { onClick: closeTips, type: "primary", style: {
                    width: 76,
                } }, "\u77E5\u9053\u4E86"))));
};
const dataStoreApi = apiHolder.api.getDataStoreApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = apiHolder.api.getSystemApi();
const inEdm = systemApi.inEdm();
export function splitHTMLByRules(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    let result = [];
    let currentChunk = [];
    function shouldSplit(node) {
        if (node.nodeType !== Node.ELEMENT_NODE)
            return false;
        const tag = node.tagName.toLowerCase();
        const classList = node.classList || [];
        const id = node.id;
        const text = node.textContent.trim();
        if (tag === 'blockquote' && node.getAttribute('type') === 'cite')
            return true;
        if (tag === 'div' &&
            Array.from(classList).some(c => c.includes('foxmail_blockquote_fromhere_element') || c.includes('ntes-mailmaster-quote') || c.includes('pre-mail-content') || c.includes('gmail_quote')))
            return true;
        if (tag === 'div' && text === '------------------ 原始邮件 ------------------')
            return true;
        if (tag === 'div' && id.includes('divRplyFwdMsg'))
            return true;
        return false;
    }
    function traverse(node) {
        if (shouldSplit(node)) {
            if (currentChunk.length > 0) {
                result.push(currentChunk.join(''));
                currentChunk = [];
            }
        }
        else if (node.nodeType === Node.TEXT_NODE) {
            currentChunk.push(node.data);
        }
        if (node.childNodes && node.childNodes.length > 0) {
            Array.from(node.childNodes).forEach(child => {
                if ((child === null || child === void 0 ? void 0 : child.tagName) !== 'SCRIPT') {
                    traverse(child);
                }
            });
        }
    }
    traverse(doc.body);
    if (currentChunk.length > 0) {
        result.push(currentChunk.join(''));
    }
    if (result.length > 0) {
        result = result.map(item => {
            const contactInfo = [];
            const fromPattern = [/From：(\S+)\s+<([^>]+)>/, /发件人: (\S+)\s+<([^>]+)>/];
            const toPattern = [/To：(\S+)\s+<([^>]+)>/, /收件人: (\S+)\s+<([^>]+)>/];
            let fromMatch = [];
            let toMatch = [];
            while (fromPattern.length) {
                const fromPatternCur = fromPattern.shift();
                if (item.match(fromPatternCur)) {
                    fromMatch = item.match(fromPatternCur);
                    break;
                }
            }
            while (toPattern.length) {
                const toPatternCur = toPattern.shift();
                if (item.match(toPatternCur)) {
                    toMatch = item.match(toPatternCur);
                    break;
                }
            }
            return {
                content: item,
                receiver: toMatch[1] || '',
                receiver_name: toMatch[2] || '',
                sender: fromMatch[1] || '',
                sender_name: fromMatch[2] || '',
                receive_time: '',
                subject: '',
                mid: '',
            };
        });
    }
    return result.filter(Boolean);
}
const HOCAiWriteMail = (Component) => {
    const AiWriteMailWrapped = (props) => {
        const { ref, aiWriteMailAction, source, mailLangType, originMailId, aiWriteMailUse, onEditCreated } = props, rest = __rest(props, ["ref", "aiWriteMailAction", "source", "mailLangType", "originMailId", "aiWriteMailUse", "onEditCreated"]);
        const from = props.init.from;
        const [aiWriteType, setAiWriteType] = useState('write');
        const editorRef = useRef();
        const aiWriteTemplate = useRef(null);
        const [aiWriteVisible, setAiWriteVisible] = useState(false);
        const [aiWriteRemindVisible, setAiWriteRemindVisible] = useState(false);
        const [insertAiWriteRemindChecked, setInsertAiWriteRemindChecked] = useState(false);
        const [AIWriteContentionShow, setAIWriteContentionShow] = useState(false);
        const [attentionPos, setAttentionPos] = useState({ top: 0, left: 0 });
        const [refreshCount, setRefreshCount] = useState(0);
        const [content, setContent] = useState('');
        const [visible, setVisible] = useState(false);
        const [tipPos, setTipPos] = useState({
            top: 0,
            left: 0,
        });
        const setVisibleRef = useRef(setVisible);
        const setTipPosRef = useRef(setTipPos);
        const chatDrawerController = useChatDrawerController();
        const showAiAssistant = useShowAiAssistant();
        setVisibleRef.current = setVisible;
        setTipPosRef.current = setTipPos;
        const getCurrentMailText = useCallback(type => {
            var _a, _b;
            if (type === 'select') {
                return (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.selection.getContent({ format: 'text' });
            }
            const editorBody = (_b = editorRef.current) === null || _b === void 0 ? void 0 : _b.getContent();
            if (editorBody) {
                return getMailContentText({ content: editorBody, removeUnSubText: true });
            }
        }, [editorRef.current]);
        const addTemplateContent = (content) => {
            if (editorRef.current) {
                editorRef.current.insertContent(content);
            }
        };
        const insertAiWriteTemplate = () => {
            setAiWriteRemindVisible(false);
            setAiWriteVisible(false);
            if (aiWriteTemplate.current) {
                addTemplateContent(aiWriteTemplate.current);
            }
        };
        const getAiWriteResult = (content) => {
            aiWriteTemplate.current = content;
            dataStoreApi.get('mailAiWriteRemind').then(v => {
                var _a;
                const curContent = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.getContent();
                const empty = isEmpty(curContent !== null && curContent !== void 0 ? curContent : '');
                if (v.data === '1' || empty) {
                    insertAiWriteTemplate();
                }
                else {
                    setAiWriteRemindVisible(true);
                }
            });
        };
        const changeAiWriteTempRemind = async (e) => {
            setInsertAiWriteRemindChecked(e.target.checked);
            const val = e.target.checked ? '1' : '0';
            await dataStoreApi.put('mailAiWriteRemind', val);
        };
        const onAiWriteRemindCancel = async () => {
            setAiWriteRemindVisible(false);
        };
        const onEditCreatedPipe = (editor) => {
            onEditCreated && onEditCreated(editor);
            editorRef.current = editor;
        };
        const aiWriteMailActionPipe = (type) => {
            let content = getCurrentMailText(type);
            setAiWriteType('write');
            if (content === null || content === void 0 ? void 0 : content.length) {
                setAiWriteType('retouch');
            }
            if (type === 'select')
                setAiWriteType('retouch');
            content = content.replace(/(查看推荐模版)|(查看商品插入示例)|(添加商品)\s/g, '');
            setContent(content);
            setVisibleRef.current(false);
            setAiWriteVisible(true);
            aiWriteMailAction && aiWriteMailAction(type);
            trackApi.track('pcMail_click_AiWriteButton_writeMailPage');
        };
        const aiSelectBefore = () => {
            let elem = document.querySelector('.ai-writemail-btn');
            while (elem) {
                if (elem.className.includes('tox-toolbar__group')) {
                    break;
                }
                elem = elem.parentElement;
            }
            const elemRect = elem.getBoundingClientRect();
            setVisibleRef.current(true);
            setTipPosRef.current({
                top: elemRect.top + 40,
                left: elemRect.left,
            });
        };
        const closeTips = () => {
            setAIWriteContentionShow(false);
        };
        const AIWriteContentionShowAction = (pos) => {
            setAttentionPos(pos);
            setAIWriteContentionShow(true);
        };
        useEffect(() => {
            setRefreshCount(refreshCount + 1);
        }, [aiWriteType]);
        const aiReplay = () => {
            var _a;
            const editorBody = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.getContent();
            let contentList = splitHTMLByRules(editorBody);
            console.log(contentList);
            if (contentList.length < 2) {
                message.error('请先引用原邮件回复，再进行AI助理回复');
                return;
            }
            chatDrawerController === null || chatDrawerController === void 0 ? void 0 : chatDrawerController.openChatDrawer({
                type: AiAsstWmBizType.EMAIL_REPLY,
                params: {
                    lang: mailLangType,
                    assistant_id: '',
                    chat_id: '',
                    mid: originMailId,
                    option_info: '',
                    quote_email_list: contentList,
                },
            });
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, onEditCreated: onEditCreatedPipe, aiWriteMailAction: inEdm && from === 'mailWrite' ? aiSelectBefore : aiWriteMailActionPipe, AIWriteContentionShowAction: AIWriteContentionShowAction })),
            AIWriteContentionShow && (React.createElement(LxPopover, { top: attentionPos.top, left: attentionPos.left, visible: AIWriteContentionShow, setVisible: closeTips },
                React.createElement(AIWriteAttention, { closeTips: closeTips }))),
            aiWriteVisible && (React.createElement(AiWriteMail, { key: refreshCount, source: source, onUse: aiWriteMailUse, type: aiWriteType, setAiWriteType: setAiWriteType, getCurrentMailText: getCurrentMailText, originalContent: content, editorRef: editorRef, visible: aiWriteVisible, onClose: () => {
                    setAiWriteVisible(false);
                }, aiInsertContent: getAiWriteResult })),
            React.createElement(LxPopover, { top: tipPos.top, left: tipPos.left, resetStyle: { zIndex: 999 }, visible: visible, setVisible: setVisible, acceptTopBottom: true },
                React.createElement("div", { className: classnames(style.aiAssistantBoxWrap, style.fontCommaBoxWrap) },
                    React.createElement("div", { className: classnames([style.aiAssistantItem]), onClick: () => {
                            aiWriteMailActionPipe('write');
                        } }, "\u5199\u4FE1/\u6DA6\u8272"),
                    showAiAssistant && (React.createElement("div", { className: classnames([style.aiAssistantItem]), onClick: aiReplay }, "\u56DE\u590D")))),
            inEdm && React.createElement(ChatDrawer, Object.assign({}, chatDrawerController)),
            React.createElement(Modal, { width: 400, centered: true, visible: aiWriteRemindVisible, maskClosable: false, onCancel: onAiWriteRemindCancel, destroyOnClose: true, footer: null, closable: false },
                React.createElement("div", { className: style.mailRemindContent },
                    React.createElement("div", { className: style.mailRemindLeft },
                        React.createElement(WarnIcon, null)),
                    React.createElement("div", null,
                        React.createElement("p", { className: style.mailRemindText }, "\u68C0\u6D4B\u5230\u5199\u4FE1\u9875\u5DF2\u6709\u5185\u5BB9\uFF0CAI\u751F\u6210\u5185\u5BB9\u5C06\u63D2\u5165\u5230\u5199\u4FE1\u9875\u5185\u5BB9\u540E"),
                        React.createElement("div", { className: style.mailRemindFooter },
                            React.createElement(Checkbox, { onChange: changeAiWriteTempRemind, checked: insertAiWriteRemindChecked }, getIn18Text('BUZAITIXING')),
                            React.createElement("div", { className: style.mailRemindBtns },
                                React.createElement(Button, { style: { marginRight: '16px' }, onClick: onAiWriteRemindCancel }, getIn18Text('QUXIAO')),
                                React.createElement(Button, { type: "primary", onClick: insertAiWriteTemplate }, getIn18Text('QUEDINGCHARU')))))))));
    };
    return React.forwardRef((props, ref) => React.createElement(AiWriteMailWrapped, Object.assign({}, props, { ref: ref })));
};
export default HOCAiWriteMail;
